export default __webpack_public_path__ + "static/media/React.8a6fc0a2.png";